import { HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { GbApiService } from 'libs/shared/data-access-core/src/lib/+state/gb-api.service'
import { Observable } from 'rxjs'
import { TeamsEntity } from './teams.models'
import { GbPaginatedResponse } from '@galabid/gb-dashboard/core/data-access'

@Injectable({
  providedIn: 'root',
})
export class TeamsApiService extends GbApiService {
  getTeams(
    urlName: string,
    offset: number,
    searchTerm?: string,
    ordering?: string,
  ): Observable<GbPaginatedResponse<TeamsEntity>> {
    let params = new HttpParams().set('limit', this.appConfig.itemsPageSize).set('offset', offset)
    if (searchTerm) params = params.set('search', searchTerm)
    if (ordering) params = params.set('ordering', ordering)

    const url = `auctions/${urlName}/teams/`
    return this.get<GbPaginatedResponse<TeamsEntity>>(url, { params })
  }

  createTeam(urlName: string, team: Partial<TeamsEntity>): Observable<TeamsEntity> {
    const url = `auctions/${urlName}/teams/`
    return this.post<TeamsEntity>(url, team)
  }

  updateTeam(urlName: string, team: Partial<TeamsEntity>): Observable<TeamsEntity> {
    const url = `auctions/${urlName}/teams/${team.uuid}/`
    return this.patch<TeamsEntity>(url, team)
  }

  deleteTeam(urlName: string, team: TeamsEntity) {
    const url = `auctions/${urlName}/teams/${team.uuid}/`
    return this.delete<void>(url)
  }

  assign(urlName: string, teamUuid: string, profiles: string[]) {
    const url = `auctions/${urlName}/teams/${teamUuid}/assign/`
    return this.post<void>(url, { profiles })
  }

  remove(urlName: string, teamUuid: string, profiles: string[]) {
    const url = `auctions/${urlName}/teams/${teamUuid}/remove/`
    return this.post<void>(url, { profiles })
  }
}
